import React from 'react';

import { useTranslation } from "core/hooks/useTranslation";
import useDate from "core/hooks/useDate";

import Icon from "core/ui-kit/icon";


const OverlappedCommissions = ({
   overlappedCommissions,
   clearOverlappedCommissionsErrors,
}) => {
    const { t } = useTranslation();
    const { dateService } = useDate();

    return (
        <div className="rt--overlapped-commissions-view">
            <Icon name="error-alert"/>
            <div className="rt--overlapped-items-wrapper">
                <span className='rt--overlapped-message'>{`${t('backoffice.commissionplans.overlapMessage')}:`}</span>
                <div className="rt--overlapped-grid">
                    {
                        overlappedCommissions.map((item) => {
                            const { commissionPlanName: name, startDate, endDate, commissionPlanId } = item;
                            const start = dateService.format(startDate);
                            const end = dateService.format(endDate);
                            return (
                                <div className="rt--overlapped-item" key={commissionPlanId}>
                                    {`${name}: ${t('backoffice.commissionplans.start')} ${start} | ${t('backoffice.commissionplans.end')} ${end}`}
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <span onClick={clearOverlappedCommissionsErrors} style={{ cursor: 'pointer' }}>
                <Icon name="close"/>
            </span>
        </div>
    )
}

export default OverlappedCommissions;
